import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { UserAvatarInfo } from './domain';

@Component({
    selector: 'app-bx-user-avatar',
    imports: [CommonModule],
    templateUrl: './bx-user-avatar.component.html',
    styleUrls: ['./bx-user-avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BxUserAvatarComponent implements OnChanges {
    @Input() avatarInfo?: UserAvatarInfo;

    initial?: string;

    ngOnChanges(): void {
        this.initial = `${this.avatarInfo?.firstName?.[0]?.toUpperCase() ?? ''}${this.avatarInfo?.surname?.[0]?.toUpperCase() ?? ''}`;
    }
}
